import { c as _c } from "react/compiler-runtime";
import { CardError, CardSkeleton } from '@/components/entity-onboarding-details';
import type { WithEntityProps } from '@/entity/components/with-entity';
import useEntityDeviceInsights from '../../../../hooks/use-entity-device-insights';
import Content from './components/content';
type DeviceInsightsProps = WithEntityProps & {
  asOf?: string;
};
const DeviceInsights = t0 => {
  const $ = _c(5);
  const {
    entity,
    asOf
  } = t0;
  const {
    error,
    data
  } = useEntityDeviceInsights(entity.id, asOf);
  if (data) {
    let t1;
    if ($[0] !== data.data || $[1] !== entity) {
      t1 = <Content entity={entity} events={data.data} />;
      $[0] = data.data;
      $[1] = entity;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== error) {
    t1 = error ? <CardError error={error} /> : <CardSkeleton rows={4} />;
    $[3] = error;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default DeviceInsights;